const l = "VVirtualListXScroll";
export {
  l as xScrollInjextionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/virtual-list/src/context.js
// module id = 953
// module chunks = 41